import { Mark as r } from "prosemirror-model";
import { hasNativeEmojiSupport as i, substituteColonifiedForUnicode as h } from "./utils/emoji.js";
class m {
  schema;
  stack;
  marks;
  docNode;
  constructor(t) {
    this.schema = t, this.stack = [{ type: t.topNodeType, infoContent: [], content: [] }], this.marks = r.none;
  }
  get doc() {
    if (!this.docNode) {
      if (this.stack.length !== 1)
        throw new Error("Document has unclosed nodes");
      this.docNode = this.closeNode();
    }
    return this.docNode;
  }
  top() {
    return this.stack[this.stack.length - 1];
  }
  push(t) {
    this.stack.length && this.top().content.push(t);
  }
  openNode(t, e) {
    this.stack.push({ type: t, attrs: e, infoContent: [], content: [] });
  }
  closeNode() {
    const t = this.stack.pop();
    if (!t)
      throw new Error("Tried to close a non existent node");
    const e = t.type.createAndFill(t.attrs, t.content, this.marks);
    if (!e)
      throw new Error("Undefined node type");
    return this.push(e), e;
  }
  addText(t) {
    if (!t)
      return;
    i() || (t = h(t));
    const e = this.top().content, s = e[e.length - 1], o = this.schema.text(t, this.marks), n = s && this.maybeMerge(s, o);
    n ? e[e.length - 1] = n : e.push(o);
  }
  openMark(t) {
    this.marks = t.addToSet(this.marks);
  }
  closeMark(t) {
    this.marks = t.removeFromSet(this.marks);
  }
  maybeMerge(t, e) {
    if (t.isText && e.isText && r.sameSet(t.marks, e.marks))
      return t.withText(t.text + e.text);
  }
}
export {
  m as DocumentBuilder
};
